
import type { PropOptions } from 'vue';
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import PublicPortfolioModal from '~/components/partials/public-portfolio/PublicPortfolioModal.vue';
import BravadoCallout from '~/components/common/BravadoCallout/BravadoCallout.vue';
import BravadoToggle from '~/components/common/BravadoToggle/BravadoToggle.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoTextInputV3 from '~/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';
import { resettable } from '~/components/global/mixins';

export default Vue.extend({
  name: 'PublicPortfolioHeadlineModal',
  components: { PublicPortfolioModal, BravadoCallout, BravadoToggle, BravadoButtonV3, BravadoTextInputV3 },
  mixins: [resettable],
  props: {
    headline: {
      type: String,
      default: '',
    } as PropOptions<string>,
  },
  data() {
    return {
      description: this.headline,
    };
  },
  computed: {
    ...mapState('portfolio', ['configuration']),
  },
  methods: {
    ...mapActions('portfolio', ['updateUser', 'updatePortfolioConfig']),
    async onSubmit(): Promise<void> {
      try {
        await this.updateUser({ user: { description: this.description } });
        this.$notice.success('Profile updated');
        this.$modal.hide(this.$constants.dynamicModals.PUBLIC_PORTFOLIO_HEADLINE_MODAL);
      } catch (e) {
        this.$notice.error('Could not update profile. Please try again later');
        this.$sentryUtils.error(e);
      }
    },
    async onVisibilityChange(value: boolean): Promise<void> {
      await this.updatePortfolioConfig({ configuration: { section_headline_is_public: value } });
    },
    onCancelClick(): void {
      this.$modal.hide(this.$constants.dynamicModals.PUBLIC_PORTFOLIO_HEADLINE_MODAL);
      //  @ts-ignore
      this.resetData();
    },
  },
});
